import { makeStyles } from '@material-ui/core/styles';

// Note: this project's MUI theme is configured with `spacing: 4` (see
// core/components/theme/theme.jsx:45), so theme.spacing(1) === 4px, not the MUI
// default of 8px. Multiply your intended pixel value by ¼ when picking an argument.

export default makeStyles((theme) => ({
  card: {
    padding: theme.spacing(8),
    marginBottom: theme.spacing(4)
  },
  title: {
    color: theme.colorPalette.green_80,
    fontSize: 20,
    fontWeight: 400
  },
  innerCard: {
    marginTop: theme.spacing(4),
    borderRadius: theme.sizes.roundCorners,
    overflow: 'hidden'
  },
  innerCardTop: {
    // 9px y / 16px x per design — y value is off the 4px theme.spacing scale, so the
    // string form is used directly here.
    padding: '9px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.colorPalette.beige_50
  },
  icon: {
    height: 40,
    width: 40,
    marginLeft: theme.spacing(2)
  },
  innerCardTopTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.colorPalette.green_90
  },
  innerCardTopSubtitle: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.colorPalette.green_80
  },
  innerCardBottom: {
    display: 'flex',
    padding: theme.spacing(4),
    // Keeps the row height consistent between the success state (two-line price block)
    // and the "Price available inside" fallback (single-line label) so the 16px padding
    // reads visually the same in both.
    minHeight: 72,
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.colorPalette.beige_25
  },
  innerCardBottomTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.colorPalette.green_90,
    display: 'block'
  },
  innerCardBottomValue: {
    fontSize: 24,
    color: theme.colorPalette.green_90,
    display: 'flex',
    alignItems: 'center'
  },
  pricePerMonthText: {
    fontSize: 12,
    color: theme.colorPalette.green_80,
    marginLeft: theme.spacing(1)
  },
  // Fallback in the price slot when the rater didn't surface a monthly premium — keeps
  // the row populated so the operator still has a clear CTA to bridge into Branch staff.
  priceAvailableText: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.colorPalette.green_90
  },
  branchBranding: {
    display: 'flex',
    alignItems: 'center'
  },
  divider: {
    alignSelf: 'stretch',
    width: 1,
    backgroundColor: theme.colorPalette.beige_50,
    marginRight: theme.spacing(4)
  },
  branchLogo: {
    height: 24,
    width: 'auto'
  },
  loadingRow: {
    minHeight: 200
  },
  actionSection: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));
